import { WidgetStreamStreamingConfig } from 'widgets/streaming/WidgetStreamConfig';
import { PortfolioPlStreamRequest } from 'communication/types/portfolioPl/PortfolioPlStreamRequest';
import { PortfolioPlElement } from 'communication/types/portfolioPl/PortfolioPlElement';
import { buildPortfolioPlStreamSlice } from 'widgets/portfolioPl/store/stream/streamSlice';
import { createPortfolioPlStreamRequest } from 'widgets/portfolioPl/store/stream/PortfolioPlStreamRequest';

const { actions, selectors } = buildPortfolioPlStreamSlice();

export const streamConfig: WidgetStreamStreamingConfig<
    PortfolioPlStreamRequest,
    PortfolioPlElement
> = {
    streamType: 'StreamingStream',
    configType: 'OrderIdsDependentWidgetStreamConfig',
    startChannelDestination: 'startPLGraphStream',
    createPayload: createPortfolioPlStreamRequest,
    selectWidgetStreamKey: selectors.selectStreamKey,
    clearWidgetStreamData: actions.createClearStreamDataAction,
    subscriptions: {
        widgetConfig: true,
        appSettings: true,
    },
};
